import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    if (authService.isAuthenticated) {
      const USER_ROLE = authService.user[process.env["VUE_APP_ROLE_KEY"]];
      const IS_MOBILE_USER = USER_ROLE.indexOf("Installer") !== -1;
      if (IS_MOBILE_USER && USER_ROLE.length == 1) {
        return next("/accessdenied");
      }
      return next();
    }
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", (loading) => {
    if (loading === false) {
      return fn();
    }
  });
};
